/**
 * returns the file type from base64 magic bytes
 */
export function getBase64PdfOrImageType(base64Data: string): string {
  if (base64Data.startsWith("JVBERi")) return "application/pdf";
  if (base64Data.startsWith("iVBORw0KGgo")) return "image/png";
  if (base64Data.startsWith("/9j/")) return "image/jpeg";
  if (base64Data.startsWith("R0lGODdh") || base64Data.startsWith("R0lGODlh")) return "image/gif";
  if (base64Data.startsWith("UklGR")) return "image/webp";
  if (base64Data.startsWith("SUkq") || base64Data.startsWith("TU0A")) return "image/tiff";
  if (base64Data.startsWith("Qk")) return "image/bmp";

  return ""; // not a pdf or image
}

/**
 * Checks if content type is an image
 */
export function isImageType(contentType: string): boolean {
  return contentType.startsWith("image/");
}

/**
 * Checks if content type is a PDF
 */
export function isPdfType(contentType: string): boolean {
  return contentType === "application/pdf";
}

/**
 * Removes quotes from base64 string
 */
export function cleanBase64String(base64Data: string): string {
  return base64Data.replace(/"/g, "");
}

/**
 * Converts base64 string to Blob
 * This provides better security by sandboxing the PDF in a unique origin
 */
export function base64ToBlob(base64: string, mimeType: string): Blob {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}

/**
 * Creates a Blob URL from base64 content
 * Returns undefined on failure
 */
export function createBlobUrl(base64: string, mimeType: string): string | undefined {
  try {
    const blob = base64ToBlob(base64, mimeType);
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Failed to create blob URL:", error);
    return undefined;
  }
}
